module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAeBAMAAAC/JAEaAAAAKlBMVEUAAAD///////////////////////////////////////////////////+Gu8ovAAAADXRSTlMA8KxTMKK04VpOODQQSnev8AAAAFNJREFUGNNjAANWQSAIYEAAtrtAkIAkwAQSUKCJwCIlJSVVZIFeEIksYAskLjJMNjY2tkEWADFvIwvIAskrowIoAXQFEpWQMC0ERrMIJLInAglxAC+++KMGVg2hAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/images/icon1.png
// module id = E/c3
// module chunks = 1